<template>
<div class="map-container">
    <l-map rel="map" :zoom="zoom" :bounds="bounds" >
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <v-marker-cluster :options="clusterOptions">
        <l-marker v-for="marker in markers" :lat-lng="marker.ll" :key="marker.data.id" :icon="marker.icon">
            <l-popup>
                <div>
                    <div class="top-name">
                        <img class="small-ico" :src="marker.data.iconURL"> {{marker.data.name}}
                    </div>
                    <hr>
                    <!-- <div class="top-actions">
                        <router-link tag="button" class="btn btn-warning btn-sm" :to="goTo(marker.data)">SHOW</router-link>
                    </div> -->
                </div>
            </l-popup>
        </l-marker>
      </v-marker-cluster>
    </l-map>
</div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from 'vue2-leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'
import _ from 'underscore';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
    name: 'MapComponent',
    props:{
        shops:{
            type: [Array, Object]
        }
    },
    data(){
        return {
            map: null,
            zoom:13,
            url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            iconSize: 64,
            boundsz: null,
            clusterOptions: {
                showCoverageOnHover: false,
                removeOutsideVisibleBounds: true,
            }
        }
    },
    computed:{
        bounds(){
            const pointlist = _.map(this.markers,(mark) => mark.ll);
            const bounds = new L.latLngBounds(pointlist);
            return bounds;
        },
        dynamicSize () {
            return [this.iconSize, this.iconSize * 1.15];
        },
        dynamicAnchor () {
            return [this.iconSize / 2, this.iconSize * 1.15];
        },
        markers(){
            if(!this.shops){
                return [];
            }
            if(this.shops.length === undefined && typeof this.shops === 'object'){
                return [this.prepareShopForMarker(this.shops)]
            }
            if(this.shops.length > 0){
                const t = _.map(this.shops, this.prepareShopForMarker);
                return t.filter((v)=>v !== undefined);
            }
            return [];
            
        }
    },
    methods: {
        goTo(data){
            return `${data.id}`;
        },
        prepareShopForMarker(shop){
            if(shop.address){
                const toDisplay = {};
                toDisplay.ll = L.latLng(shop.address.latitude, shop.address.longitude).wrap();
                toDisplay.data = shop;
                if(shop.iconURL.indexOf('http') > -1){
                    toDisplay.icon = L.icon({
                        iconUrl: shop.iconURL,
                        iconSize: [32, 37],
                        iconAnchor: [16, 37]
                    });
                }
                return toDisplay;
            }else{
                return undefined;
            }
        },
        zoomUpdated (zoom) {
            this.zoom = zoom;
        },
        centerUpdated (center) {
            this.center = center;
        },
        boundsUpdated (bounds) {
            this.boundsz = bounds;
        }
    },
    components: { LMap, LTileLayer, LMarker, LPopup, LIcon, 'v-marker-cluster': Vue2LeafletMarkerCluster }
}
</script>

<style lang="scss">
  @import "~leaflet/dist/leaflet.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
    .map-container{
        width: 100%;
        height: 300px;
    }
    .small-ico{
        width: 30px;
        height: auto;
    }
</style>
